// src/pages/admin/SeriesCreatePage.js
import React from "react";
import SeriesForm from "./organisms/SeriesForm";
import { Container, Typography } from "@mui/material";

const SeriesCreatePage = () => {
  return (
    <Container maxWidth="md">
      <Typography variant="h4" sx={{ my: 2 }}>
        Series Management
      </Typography>
      <SeriesForm />
    </Container>
  );
};

export default SeriesCreatePage;
